import React from "react";
import '../assets/styles/timeline/index.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faCalendarAlt, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

// Componente Status agora recebe 'status' diretamente ('ativo' ou 'inativo')
const Status = ({ status }) => {
    const isActive = status === 'ativo'; // Verifica diretamente o status
    return (
        <div className={`small-status ${isActive ? 'active' : 'inactive'}`}>
            <FontAwesomeIcon icon={faCheckCircle} />
            <p>{isActive ? 'Ativo' : 'Inativo'}</p>
        </div>
    );
};

const Timeline = ({ data, actions }) => {
    // getFilteredActions agora usa item.status e a função 'show' da action
    const getFilteredActions = (item) => {
        return actions?.filter(action => {
            // A lógica de filtragem foi movida para a propriedade `show` de cada action
            // se `action.show` for uma função, ela é chamada com o item
            // caso contrário, a ação é mostrada por padrão
            if (typeof action.show === 'function') {
                return action.show(item);
            }
            return true; // Se não houver `show` definido, exibe a ação
        });
    };

    return (
        <div className="timeline">
            {data.map((item, index) => {
                // Ensure item.date is valid before creating Date object
                const eventDate = item.date ? new Date(item.date) : null;
                const formattedDate = eventDate ? eventDate.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : 'Data indisponível';

                const filteredActions = getFilteredActions(item);
                return (
                    <div key={index} className={`container-timeline ${index % 2 === 0 ? 'left-container' : 'right-container'}`}>
                        <div className="icon-chevron">
                            <FontAwesomeIcon icon={faChevronDown} />
                        </div>
                        <div className="text-box-timeline">
                            <div className="text-box-timeline-title">
                                <h2>{item.title}</h2>
                                <div className="text-box-timeline-title-actions">
                                    {/* Mapeia apenas as ações filtradas */}
                                    {filteredActions?.map((action, idx) => (
                                        <button
                                            key={idx}
                                            type="button"
                                            className={`btn btn-sm ${action.buttonClass} btn-tooltip mr-1`}
                                            title={action.title}
                                            onClick={() => action.onClick(item)}
                                        >
                                            <FontAwesomeIcon icon={action.icon} />
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <small>
                                <div className="small-date">
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                    {formattedDate}
                                </div>
                                {/* Passa a propriedade 'status' para o componente Status */}
                                <Status status={item.status} />
                            </small>
                            <p dangerouslySetInnerHTML={{ __html: item.description }}></p>
                            <span className={`${index % 2 === 0 ? 'left-container-arrow' : 'right-container-arrow'}`}></span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default Timeline;